import {
	Component,
	OnInit,
	OnChanges,
	Input,
	ElementRef,
	Output,
	EventEmitter,
} from "@angular/core";

@Component({
	selector: "app-videowithtranscript",
	templateUrl: "./videowithtranscript.directive.html",
	styleUrls: ["./videowithtranscript.directive.css"],
})
export class VideowithtranscriptDirective implements OnChanges {
	@Input() layout: string; //horizontal,vertical
	@Input() video_url: string;
	@Input() video_width?: string;
	@Input() video_height?: string;
	@Input() video_autoplay?: Boolean;
	@Input() video_controls?: Boolean;
	@Input() video_loop?: Boolean;
	@Output() video_startHandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() video_completehandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() video_pausehandler?: EventEmitter<any> = new EventEmitter<any>();

	@Input() transcripttitle?: string;
	@Input() transcripttext: string;
	@Input() tt_width?: string;
	@Input() tt_height?: string;
	@Input() tt_borderradius?: string;
	@Input() tt_borderwidth?: string;
	@Input() tt_bordercolor?: string;
	@Input() tt_borderstyle?: string;
	@Input() tt_hpadding?: string;
	@Input() tt_vpadding?: string;
	@Input() tt_bgcolor?: string;
	@Input() tt_fontsize?: string;
	@Input() tt_fontcolor?: string;

	constructor(private elementRef: ElementRef) {}
	ngOnChanges(changes) {}
	public videostarthandler(event) {
		this.video_startHandler.emit(event);
	}
	public videocompletehandler(event) {
		this.video_completehandler.emit(event);
	}
	public videopausehandler(event) {
		this.video_pausehandler.emit(event);
	}
}
